import { render, staticRenderFns } from "./_footerMarketplace.vue?vue&type=template&id=69b1c190"
import script from "./_footerMarketplace.vue?vue&type=script&lang=js"
export * from "./_footerMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports